import TemplateView from "../../../TemplateView"

export default class SortLink extends TemplateView {
    constructor({
        title = '',
        clazz = '',
    }) {
        super(null)

        this.title = title
        this.clazz = clazz

        this.state = {
            asc: false,
            active: false,
        }

        this.onStatePropertyChanged('asc', () => {
            this.getEl().toggleClass('asc', this.state.asc)
        })
        this.onStatePropertyChanged('active', () => {
            this.getEl().toggleClass('active', this.state.active)
        })
    }

    templateHtml() {
        return '<div class="sortLink <%=clazz%>"><%-title%></div>'
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/SortLink.js